import { FC, ReactNode } from "react";
import { Box, Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { FormattedMessage } from "react-intl";

interface FieldLabelWithCompletionProps {
    label: ReactNode;
    showCompletionInfo: boolean;
}

export const FieldLabelWithCompletion: FC<FieldLabelWithCompletionProps> = ({ label, showCompletionInfo }) => (
    <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}>
        {label}
        {showCompletionInfo && (
            <Tooltip title={<FormattedMessage id="common.title.field-with-completion" defaultMessage="This field is required to complete the step" />} arrow>
                <InfoOutlinedIcon
                    color="info"
                    sx={{ fontSize: 16, cursor: "pointer", pointerEvents: "auto" }}
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick={(e) => e.stopPropagation()}
                />
            </Tooltip>
        )}
    </Box>
);
